import { FC } from 'react'
import { PagesQA } from 'shared/dataAttributes'
import { colors, fonts, media, styles } from 'shared/lib'
import createSanitizedHtmlObject from 'shared/lib/sanitizeHtml'
import styled from 'styled-components'

const HeaderWrapper = styled.header`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${styles.mobilePageLayoutPadding};
  background-color: ${colors.FC2_WHITE};
  ${media.large`
    margin-bottom: 40px;
    align-items: center;
    background-color: ${colors.FC2_WHITE};
    padding: 80px 150px;
  `};
`
const Meta = styled.div<{ align: string }>`
  max-width: 800px;
  display: flex;
  flex-direction: column;
  flex: 0 1 45%;
  text-align: ${({ align }) => align || 'left'};
  ${media.large`
    order: 0;
    text-align: center;
  `}
`
const Title = styled.h1<{ as: string }>`
  ${fonts.HEADER_1}
  margin-top: 0;
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 4px;
  ${media.large`
    font-size: 24px;
    line-height: 26px;
    font-weight: bold;
    margin-bottom: .67em;
  `}
`
const Description = styled.div`
  margin-top: 12px;

  ${fonts.BODY_TEXT}
  a {
    color: inherit;
    text-decoration: underline;
    font: inherit;
    font-weight: 500;

    &:hover {
      filter: brightness(60%);
    }
  }

  p {
    margin-bottom: 0;
    margin-top: 0;
  }

  ${media.large`
    margin-top: 0;

    p {
      margin-bottom: 12px;
      margin-top: 12px;
    }
  `}
`

interface IGridHeaderProps {
  title: string
  description?: string
  textAlign?: string
  as?: string
}

const GridHeader: FC<IGridHeaderProps> = ({ title, description, textAlign, as = 'h1' }) => {
  return (
    <HeaderWrapper>
      <Meta align={textAlign}>
        <Title data-qa={PagesQA.GridTitle} data-testid="gridTitle" as={as}>
          {title}
        </Title>
        {description && (
          <Description
            data-qa={PagesQA.GridDescription}
            data-testid="gridDescription"
            dangerouslySetInnerHTML={createSanitizedHtmlObject(description)}
          />
        )}
      </Meta>
    </HeaderWrapper>
  )
}

export default GridHeader
